import { Views } from "react-big-calendar";
import useWindowDimensions from "./useWindowDimensions";

export default function useBigCalendar(currentView) {
  const { windowHeight } = useWindowDimensions();

  const VERTICAL_WHITE_SPACE = 440;
  const CHIP_COUNT_TO_DISPLAY = 5;
  const CHIP_HEIGHT = 80;
  const MINIMUM_PAGE_HEIGHT = VERTICAL_WHITE_SPACE + (CHIP_COUNT_TO_DISPLAY * CHIP_HEIGHT);
  const HEADER_HEIGHT = 100;

  const availableHeight = windowHeight - HEADER_HEIGHT;

  const calculatedHeight = currentView === Views.WEEK ? availableHeight : Math.max(availableHeight, MINIMUM_PAGE_HEIGHT);

  const calendarHeight = {
    height: calculatedHeight
  };

  return { calendarHeight };
}